import { createSlice } from '@reduxjs/toolkit';

/**
 * Slice to set up auth cookies and a log out functionality
 */
const authSlice = createSlice({
  name: 'auth',
  initialState: {
    user: null,
    is_authenticated: false,
    full_name: null,
    org: -1,
    user_id: -1,
    perms: [],
  },
  reducers: {
    setCredentials: (state, action) => {
      const { email_address, orgId, fullName, seq, perms } =
        action.payload;

      state.user = email_address;
      state.org = orgId;
      state.full_name = fullName;
      state.is_authenticated = true;
      state.user_id = seq;
      state.perms = perms;
    },
    logOut: state => {
      state.user = null;
      state.full_name = null;
      state.org = -1;
      state.is_authenticated = false;
      state.user_id = -1;
      state.perms = [];
    },
  },
});

export const { setCredentials, logOut } = authSlice.actions;
export default authSlice.reducer;

// selectors
export const selectCurrentUser = state => state.auth.user;
export const selectIsAuthenticated = state =>
  state.auth.is_authenticated;
export const selectFullName = state => state.auth.full_name;
export const selectUserOrganization = state => state.auth.org;
export const selectUserId = state => state.auth.user_id;
export const selectPerms = state => state.auth.perms;
